module.exports = __webpack_public_path__ + "img/T952.3649b056.jpg";